<template>
  <div>
    <div class="d-flex flex-row mb-3">
      <div class="btn-group">
        <input type="radio" class="btn-check" :value="null" v-model="year" id="all" autocomplete="off">
        <label class="btn btn-outline-primary" for="all">
          Die Letzten {{years.length}} Jahre
        </label>
        <template v-for="(cYear, index) in years">
          <input type="radio" class="btn-check" :value="cYear" v-model="year" :id="`year-${index}`" autocomplete="off">
          <label class="btn btn-outline-primary" :for="`year-${index}`">{{cYear}}</label>
        </template>
      </div>
      <hr class="flex-grow-1 mx-2">
    </div>
    <chart-bar :chart-data="chartData" :chart-options="chartOptions"></chart-bar>
  </div>
</template>

<script lang="js">
import { Bar } from 'vue-chartjs/legacy'
export const COLORS = [
  "#8B1E3F",  // Primary Brunex red
  "#2E86AB",  // Bright blue
  "#F6AE2D",  // Golden yellow
  "#86BBD8",  // Light blue
  "#33658A",  // Dark blue
  "#F26419",  // Orange
  "#55DDE0",  // Turquoise
  "#2F4858",  // Navy blue
  "#F26419",  // Bright orange
  "#99C24D",  // Lime green
  "#41B3A3",  // Teal
  "#E76F51",  // Coral
  "#2A9D8F",  // Sea green
  "#264653",  // Dark slate
  "#E9C46A"   // Sand yellow
]
const randomHsl = () => `hsla(${Math.random() * 360}, 50%, 75%, .95)`
export default {
  components: {
    'chart-bar': Bar
  },
  name: 'customer-chart',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      year: null,
    }
  },
  computed: {
    colors () {
      const colors = {}
      Object.keys(this.data.revenue).forEach((year, index) => {
        colors[year] = COLORS[index]
      })
      return colors
    },
    years () {
        return Object.keys(this.data.revenue)
    },
    selectedYears () {
        return this.year ? [this.year] : this.years
    },
    revenueFromCompanies(){
      const revenue = {}
      this.selectedYears.forEach((year, index) => {
        const companiesFromThatYear = Object.keys(this.data.revenue[year])
        companiesFromThatYear.forEach((company) => {
          const revenue_for_company = this.data.revenue[year][company] || 0
          if(!revenue[company]){
            revenue[company] = 0
          }
          revenue[company] += revenue_for_company
        })
      })
      return revenue
    },
    sortByRevenue(){
      return Object.keys(this.revenueFromCompanies).sort((a, b) => {
        return this.revenueFromCompanies[b] - this.revenueFromCompanies[a]
      })
    },
    dataSets(){
      return this.selectedYears.map((year) => {
        return {
          label: year,
          data: this.sortByRevenue.map((company) => {
            return this.data.revenue[year][company] || 0
          }),
          backgroundColor: this.colors[year]
        }
      })
    },
    chartData() {
      return { datasets: this.dataSets, labels: this.sortByRevenue }
    },
    chartOptions() {
      return {
        responsive: true,
        indexAxis: 'y',
        scaleShowValues: true,
        aspectRatio: 10/34,
        plugins: {
          tooltip: {
            callbacks: {
              label: function(tooltipItem) {
                return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(tooltipItem.parsed.x);
              }
            }
          },
        },
        scales: {
          y: {
            stacked: true,
            ticks: {
              autoSkip: false,
              padding: 10,
              fontSize: 10
            }
          },
          x: {
            stacked: true,
            position: 'top',
            ticks: {
              callback: function (value, _index, _ticks) {
                return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(value)
              }
            }
          }
        }
      }
    }
  }
}
</script>











